// extracted by mini-css-extract-plugin
module.exports = {"c1qlv971":"c1qlv971","f1nwowtt":"f1nwowtt","f1br746z":"f1br746z"};